<template>
  <div class="container mt-5">
    <b-form @submit.stop.prevent="login">
      <div id="warning">{{ test ? 'Wersja testowa' : '' }}</div>
      <app-input :model="$schema.email"></app-input>
      <app-input type="password" :model="$schema.password"></app-input>
      <b-form-group class="mt-4 text-right">
        <b-button variant="primary" type="submit">Zaloguj</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import { AuthenticationResource } from '@/resources/authentication.resource';
import schema from '@/schemas/login.schema';
export default {
  data() {
    return {
      test: ''
    };
  },
  mixins: [formMixin],
  schema,
  methods: {
    async login(event) {
      try {
        if (this.$schema.$validateAll().length === 0) {
          const response = await AuthenticationResource.login(this.$schema.$model.email, this.$schema.$model.password);
          console.log(response);
          localStorage.setItem('token', response.token);
          await this.$store.dispatch('getUser');
          this.$router.push({ name: 'employee', params: { id: this.$store.state.user.id } });
        } else {
          this.$notify({ type: 'error', title: 'Błąd', text: 'Błędnie wypełnione pola formularza' });
        }
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: 'Błędny email lub hasło' });
        console.warn(error);
      }
    }
  },
  mounted() {
    this.test = process.env.VUE_APP_TEST;
  }
};
</script>
<style>
#warning {
  color: red;
  font-weight: bold;
  text-align: center;
}
</style>
